import React from 'react';
import { motion } from 'framer-motion';
export function OpeningLead() {
  return <section className="py-24 px-4 bg-[#f5f0e8] text-[#1e2a38]" data-id="element-81">
      <div className="max-w-3xl mx-auto space-y-8" data-id="element-82">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-83">
          <p className="text-2xl font-serif italic text-[#1e2a38]/80 mb-12 text-center border-l-4 border-[#c9a07a] pl-6 py-2 bg-white/50 rounded-r-lg" data-id="element-84">
            "It usually starts the same way. You open your eyes for a second…
            and then you realize it's happening again."
          </p>

          <div className="prose prose-lg prose-slate text-[#1e2a38] mx-auto" data-id="element-85">
            <p className="font-medium" data-id="element-86">
              Not the "I can't fall asleep" problem.
            </p>
            <p data-id="element-87">The other one.</p>
            <p className="text-xl font-bold text-[#1e2a38]" data-id="element-88">
              The 3–4AM wide-awake problem.
            </p>
            <p data-id="element-89">Where your body wakes up and your brain decides it's time to:</p>
            <ul className="list-none space-y-2 pl-6 border-l-2 border-[#c9a07a]/30 my-6" data-id="element-90">
              <li className="flex items-center gap-3" data-id="element-91">
                <span className="w-1.5 h-1.5 rounded-full bg-[#c9a07a]" data-id="element-92"></span>
                Review your entire life
              </li>
              <li className="flex items-center gap-3" data-id="element-93">
                <span className="w-1.5 h-1.5 rounded-full bg-[#c9a07a]" data-id="element-94"></span>
                Worry about tomorrow
              </li>
              <li className="flex items-center gap-3" data-id="element-95">
                <span className="w-1.5 h-1.5 rounded-full bg-[#c9a07a]" data-id="element-96"></span>
                Solve menopause
              </li>
              <li className="flex items-center gap-3" data-id="element-97">
                <span className="w-1.5 h-1.5 rounded-full bg-[#c9a07a]" data-id="element-98"></span>
                Casually panic about never sleeping normally again
              </li>
            </ul>

            <p data-id="element-99">
              And the worst part is the loneliness of it. Because at 3:18AM,
              you're not "being dramatic."
            </p>
            <p data-id="element-100">
              You're doing math: <em data-id="element-101">If I fall asleep right now, I'll get…</em>
            </p>
            <p data-id="element-102">
              And every minute you stay awake makes tomorrow feel more
              expensive.
            </p>

            <div className="bg-[#1e2a38] text-white p-8 rounded-xl mt-12 shadow-xl" data-id="element-103">
              <p className="text-lg font-medium mb-2 text-[#c9a07a]" data-id="element-104">
                This guide exists for one reason:
              </p>
              <p className="text-2xl font-serif" data-id="element-105">
                So you stop improvising at 3AM. And you start running a system.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}